import ScrollOut from "scroll-out";

/* 
this activates the library scrollout and gives the options needed for the parallax effect
todo eat brains
*/
window.addEventListener("load", function() {
  ScrollOut({
    targets: ".parallax-me",
    threshold: 0,
    cssProps: {
      viewportY: true,
      visibleY: true,
      intersectY: true,
    },
  });
});
